<template>
  <v-row>
    <v-col>
      <v-card height="60px" class="transparent" flat>
        <v-btn
          :to="toComp"
          :fab="fabComp"
          :bottom="bottomComp"
          :right="rightComp"
          :fixed="fixedComp"
          :color="colorComp"
          @click="clickButton"
          :loading="loadingComp"
        >
          <slot> Add </slot>
        </v-btn>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "FloatingButton",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: true,
    },
    right: {
      type: Boolean,
      default: true,
    },
    fixed: {
      type: Boolean,
      default: true,
    },
    fab: {
      type: Boolean,
      default: false,
    },
    to: {
      type: Object,
      default: null,
    },
    color: {
      type: String,
      default: "primary",
    },
  },
  computed: {
    toComp() {
      return this.to ? this.to : null;
    },
    loadingComp() {
      return this.loading ? true : false;
    },
    bottomComp() {
      return this.bottom ? true : false;
    },
    rightComp() {
      return this.right ? true : false;
    },
    fixedComp() {
      return this.fixed ? true : false;
    },
    fabComp() {
      return this.fab ? true : false;
    },
    colorComp() {
      return this.color ? this.color : "primary";
    },
  },
  methods: {
    clickButton() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped>
</style>